module.exports = __webpack_public_path__ + "img/logo.357b7a7a.png";